import { defineStore } from 'pinia';

export const useDPStore = defineStore('dp', {
  state: () => ({
    byFacescanId: {} 
  }),
  actions: {
    getCache(facescanId) {
      return this.byFacescanId[String(facescanId)] || {};
    },
    setCache(facescanId, patch) {
      const id = String(facescanId);
      this.byFacescanId[id] = {
        ...(this.byFacescanId[id] || {}),
        ...patch,
      };
    },

    // ---------- Heatmap  ----------
    setHeatmap(facescanId, landmarkId, entry) {
      const fsId = String(facescanId);
      const lmId = String(landmarkId);
      const fs = this.byFacescanId[fsId] || {};
      const heatmaps = fs.heatmapByLandmarkId || {};
      heatmaps[lmId] = entry;
      this.setCache(fsId, { heatmapByLandmarkId: heatmaps });
    },
    getHeatmap(facescanId, landmarkId) {
      const fs = this.byFacescanId[String(facescanId)] || {};
      const heatmaps = fs.heatmapByLandmarkId || {};
      return heatmaps[String(landmarkId)];
    },

    // ---------- Classification ----------
    setClassification(facescanId, landmarkId, entry) {
      const fsId = String(facescanId);
      const lmId = String(landmarkId);
      const fs = this.byFacescanId[fsId] || {};
      const cls = fs.classificationByLandmarkId || {};
      cls[lmId] = entry; 
      this.setCache(fsId, { classificationByLandmarkId: cls });
    },
    getClassification(facescanId, landmarkId) {
      const fs = this.byFacescanId[String(facescanId)] || {};
      const cls = fs.classificationByLandmarkId || {};
      return cls[String(landmarkId)];
    },
    clearClassification(facescanId, landmarkId) {
      const fs = this.byFacescanId[String(facescanId)];
      if (fs?.classificationByLandmarkId?.[String(landmarkId)]) {
        delete fs.classificationByLandmarkId[String(landmarkId)];
      }
    },
    clearAllClassifications(facescanId) {
      const fs = this.byFacescanId[String(facescanId)];
      if (fs) fs.classificationByLandmarkId = {};
    },

    // ---------- clears ----------
    clearFacescan(facescanId) {
      delete this.byFacescanId[String(facescanId)];
    },
    clearAll() {
      this.byFacescanId = {};
    },
  },
});
